// Environment configuration - directly using environment variables
export const env = {
  // Environment identifier
  ENV: import.meta.env.VITE_ENV || 'local',

  // API Configuration
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL,

  // Google Services
  GOOGLE_MAPS_API_KEY: import.meta.env.VITE_GOOGLE_MAPS_API_KEY,
  GOOGLE_TIMEZONE_API_KEY: import.meta.env.VITE_GOOGLE_TIMEZONE_API_KEY,
  GOOGLE_OAUTH_CLIENT_ID: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID,

  // Apple Sign In (web). CLIENT_ID is the Apple "Services ID", not the iOS bundle id.
  APPLE_CLIENT_ID: import.meta.env.VITE_APPLE_CLIENT_ID,
  APPLE_REDIRECT_URI: import.meta.env.VITE_APPLE_REDIRECT_URI,

  // App Configuration
  APP_NAME: import.meta.env.VITE_APP_NAME,

  // Debug and Logging
  DEBUG: import.meta.env.VITE_DEBUG === 'true',
  LOG_LEVEL: import.meta.env.VITE_LOG_LEVEL || 'info',
};

// Helper functions for environment checks
export const isEnvironment = (envName: string): boolean => {
  return env.ENV === envName;
};

export const isProduction = (): boolean => {
  return env.ENV === 'production';
};

export const isDevelopmentOrLocal = (): boolean => {
  return env.ENV === 'local' || env.ENV === 'development';
};

export const isStaging = (): boolean => {
  return env.ENV === 'staging';
};

// Log environment info in development
if (env.ENV === 'local' || env.ENV === 'development') {
  console.log('🌍 Environment:', env.ENV);
  console.log('🔗 API Base URL:', env.API_BASE_URL);
  console.log('🐛 Debug Mode:', env.DEBUG);
}